'use client';

import {
  createContext,
  FC,
  ReactNode,
  useCallback,
  useContext,
  useMemo,
  useState
} from 'react';
interface UseGaEventContextProps {
  gaEventCaptured: {
    recentlyViewed: boolean;
    buyAgain: boolean;
    serviceRecommendation: boolean;
    myEquipment: boolean;
  };
  handleGaEventCapture: (value: string, isActive: boolean) => void;
}
const GaEventContext = createContext<UseGaEventContextProps | null>(null);
export const useGaEventContext = () => useContext(GaEventContext);

export const GaEventContextProvider: FC<{ children: ReactNode }> = ({
  children
}) => {
  const [gaEventCaptured, setGaEventCaptured] = useState({
    recentlyViewed: false,
    buyAgain: false,
    serviceRecommendation: false,
    myEquipment: false
  });

  const handleGaEventCapture = useCallback(
    (value: string, isActive: boolean) => {
      setGaEventCaptured((prev) => {
        const gaActiveTab =
          value === null
            ? {
                recentlyViewed: isActive,
                buyAgain: isActive,
                serviceRecommendation: isActive,
                myEquipment: isActive
              }
            : {
                [value]: isActive
              };

        return {
          ...prev,
          ...gaActiveTab
        };
      });
    },
    []
  );

  const memoizedGaEventCaptured = useMemo(() => {
    return {
      gaEventCaptured,
      handleGaEventCapture
    };
  }, [gaEventCaptured, handleGaEventCapture]);

  return (
    <GaEventContext.Provider value={memoizedGaEventCaptured}>
      {children}
    </GaEventContext.Provider>
  );
};
